export enum InterestDirection {
  COMPOUND = 'COMPOUND',
  PAYOUT = 'PAYOUT',
}
